import React from "react";
import { Layout } from "components/Layout/Layout";
import { FinishProvider } from "./context";
import { FinishPage } from "./FinishPage";

export const FinishIndex = () => {
  return (
    <FinishProvider>
      <Layout>
        <FinishPage />
      </Layout>
    </FinishProvider>
  );
};
